import { createSlice, configureStore } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit/dist/createAction";
import {
  NormalizedCargo,
  Route,
} from "../../../../../../domain/models/cargo-model";
import { StoreItem } from "../../../../../../domain/models/storage-item";

type separationState = {
  cargoId?: number;
  checkList: StoreItem[];
};

const initialState: separationState = {
  cargoId: undefined,
  checkList: [],
};

const checkShipmentSlice = createSlice({
  name: "checkShipment",
  initialState,
  reducers: {
    setCargoId: (state, action: PayloadAction<{ cargoId: number }>) => {
      state.cargoId = action.payload.cargoId;
    },
    setCheckList: (state, action: PayloadAction<{ list: StoreItem[] }>) => {
      state.checkList = action.payload.list;
    },
  },
});

export const checkShipmentStore = configureStore({
  reducer: checkShipmentSlice.reducer,
});

export type checkShipmentState = ReturnType<typeof checkShipmentStore.getState>;
export type checkShipmentDispatch = typeof checkShipmentStore.dispatch;
export const checkShipmentActions = checkShipmentSlice.actions;
